import { ITreeStructure } from '../models/treeStructure'

export const getAllDescendantsForItem = (parent: ITreeStructure): ITreeStructure[] => {
  return parent.nestedItems.reduce<ITreeStructure[]>(
    (acc, item) => {
      if (item.nestedItems.length > 0) {
        return [...acc, ...getAllDescendantsForItem(item)]
      }

      return [...acc, item]
    },
    [parent]
  )
}
